<template>
  <v-container fluid v-show="mostrar">
    <v-row justify="center">
      <v-col cols="12">
        <v-card class="mx-auto" elevation="0">
          <v-toolbar flat color="primarytwo" dark dense>
            <v-toolbar-title>Descarga Boleta de Pago</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="12" class="fondoparametros">
                <v-form ref="form" v-model="form.valid" lazy-validation>
                  <v-card-text class="pa-0">
                    <v-row dense>
                      <v-col cols="12" md="6" class="px-4 py-2">
                        <v-select
                          class="my-input input"
                          :items="lMeses"
                          label="Mes"
                          v-model="defaultItem.mes"
                          :rules="[(x) => !!x || 'El campo es requerido']"
                          dense
                          @change="btnListarClick"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6" class="px-4 py-2">
                        <v-text-field
                          v-model.number="defaultItem.year"
                          :rules="[(x) => !!x || 'El campo es requerido']"
                          label="Año"
                          dense
                          type="number"
                          @change="btnListarClick"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-form>
              </v-col>
              <v-col cols="12" md="12">
                <v-card-text class="pa-0">
                  <v-card elevation="0">
                    <v-data-table
                      :headers="headers"
                      :items="listado"
                      class="elevation-1"
                      :loading="griddata.loading"
                      loading-text="Cargando... Por favor espere"
                      :footer-props="{
                        'items-per-page-options': [10, 20, 30, 40, 50],
                      }"
                      dense
                      fixed-header
                    >
                      <template v-slot:item.opciones="{ item }">
                        <v-btn
                          color="red darken-1"
                          class="white--text my-2"
                          :loading="btnDescargar.loading"
                          :disabled="btnDescargar.loading"
                          x-small
                          @click.stop="btnBoletaPagoClick(item)"
                          >
                          Descargar
                          <v-icon dark small>
                            mdi-cloud-download
                          </v-icon></v-btn
                        >
                      </template>
                      <template v-slot:no-data>
                        <v-alert
                          border="bottom"
                          color="pink darken-1"
                          dark
                          class="mt-3"
                        >
                          No se encontraron registros
                        </v-alert>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-snackbar
          v-model="mensaje.snack"
          :timeout="mensaje.tiempo"
          :color="mensaje.snackColor"
          top
          right
        >
          {{ mensaje.snackText }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="mensaje.snack = false">
              <v-icon dark>mdi-close-box</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>



<script>
import axios from "axios";
import { parseISO, format } from "date-fns";
export default {
  name: "descargarBoletaPago",
  components: {},
  data: () => ({
    options: {},
    mostrar: true,
    pageCount: 0,
    griddata: {
      loading: false,
      reinicio: false, //para activar inicio
    },
    mensaje: {
      snack: false,
      snackColor: "",
      snackText: "",
      tiempo: 2000,
    },
    form: {
      deshabilita: false,
      valid: true,
    },
    listado: [],
    defaultItem: {
      tipoPlanilla: "01",
      mes: null,
      year: null,
    },
    btnDescargar: {
      loading: false,
    },
    headers: [
      {
        text: "Mes",
        value: "mes",
        sortable: false,
      },
      {
        text: "Regimen Laboral",
        value: "descripcionAbreviada",
        sortable: false,
      },
      {
        text: "Total Ingresos",
        value: "totalIngresos",
        sortable: false,
      },
      {
        text: "Total Descuentos",
        value: "totalDescuentos",
        sortable: false,
      },
      {
        text: "Total Neto",
        value: "totalNeto",
        sortable: false,
      },
      { text: "Opciones", value: "opciones", sortable: false },
    ],
    search: "",

    lMeses: [
      {
        text: "Enero",
        value: "01",
      },
      {
        text: "Febrero",
        value: "02",
      },
      {
        text: "Marzo",
        value: "03",
      },
      {
        text: "Abril",
        value: "04",
      },
      {
        text: "Mayo",
        value: "05",
      },
      {
        text: "Junio",
        value: "06",
      },
      {
        text: "Julio",
        value: "07",
      },
      {
        text: "Agosto",
        value: "08",
      },
      {
        text: "Setiembre",
        value: "09",
      },
      {
        text: "Octubre",
        value: "10",
      },
      {
        text: "Noviembre",
        value: "11",
      },
      {
        text: "Diciembre",
        value: "12",
      },
      {
        text: "Todos",
        value: "todos",
      },
    ],
  }),
  watch: {},
  created: function () {
    this.defaultItem.year = this.mtyearactual();
    this.defaultItem.mes = "todos";
  },
  mounted: function () {
    this.btnListarClick();
  },
  methods: {
    apiListar(data) {
      return new Promise((resolve, reject) => {
        let url =
          "api/boletaPago/List/" +
          data.mes +
          "/" +
          data.year +
          "/" +
          data.persona;
        let configuracion = {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        };
        axios
          .get(url, configuracion)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    apiBoletaPago(data) {
      return new Promise((resolve, reject) => {
        let url = "api/boletaPago/DescargarBoleta/" + data.idPlanillaPersona;
        let configuracion = {
          headers: { Authorization: "Bearer " + this.$store.state.token },
          responseType: "blob",
        };
        axios
          .get(url, configuracion)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async btnListarClick() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        this.griddata.loading = true;
        this.listado = [];

        let data = {
          mes: this.defaultItem.mes,
          year: this.defaultItem.year,
          persona: this.$store.state.usuario.idUsuario,
        };
        const respuesta = await this.apiListar(data);
        if (respuesta) {
          this.listado = respuesta.result;
        }
      } catch (error) {
        if (error.response === null || error.response === undefined) {
          this.mensaje.snackColor = "colorErrorLocal";
          this.mensaje.snackText = error;
          this.mensaje.snack = true;
        } else {
          this.mensaje.snackColor = "colorErrorServer";
          this.mensaje.snackText = await this.$store.dispatch(
            "errorMensaje",
            error.response
          );
          this.mensaje.snack = true;
        }
      } finally {
        this.griddata.loading = false;
      }
    },
    async btnBoletaPagoClick(item) {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }
        this.btnDescargar.loading = true;
        this.form.deshabilita = true;
        let data = {
          idPlanillaPersona: item.idPlanillaPersona,
        };
        const respuesta = await this.apiBoletaPago(data);
        if (respuesta) {
          let nombrearchivo =
            "Boleta Pago " +
            item.nro_doc_identidad +
            "-" +
            item.codigo +
            ".pdf";
          const url = window.URL.createObjectURL(new Blob([respuesta]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nombrearchivo);
          document.body.appendChild(link);
          link.click();
        }
      } catch (error) {
        if (error.response === null || error.response === undefined) {
          this.mensaje.snackColor = "colorErrorLocal";
          this.mensaje.snackText = error;
          this.mensaje.snack = true;
        } else {
          this.mensaje.snackColor = "colorErrorServer";
          this.mensaje.snackText = await this.$store.dispatch(
            "errorMensaje",
            error.response
          );
          this.mensaje.snack = true;
        }
      } finally {
        this.btnDescargar.loading = false;
        this.form.deshabilita = false;
      }
    },
    mtformatDate(value) {
      return value ? format(parseISO(value), "dd-MM-yyyy") : "";
    },
    mtyearactual() {
      let currentTime = new Date();
      let year = currentTime.getFullYear();
      return year;
    },
  },
};
</script>
